import React from 'react';
import Chrome from 'react-color/lib/Chrome';
import { withState, withHandlers, compose } from 'recompose';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import './BackgroundEditor.scss';


const BackgroundEditorBase = ({ formBgColor, showPicker, togglePicker, handleChangeComplete }) =>
  <div className="background-editor">
    <div className="background-editor__heading">Background</div>
    <div className="background-editor__text">Color</div>
    <div>
      <div className="background-editor__color-line">
        <div
          className="background-editor__color-box"
          style={{ backgroundColor: formBgColor }}
        />
        <Button
          className="background-editor__button"
          purple
          invert={!showPicker}
          onClick={togglePicker}
        >
          {formBgColor}
        </Button>
      </div>
      <div>
        {showPicker && (
          <Chrome
            className="background-editor__picker"
            color={formBgColor}
            onChangeComplete={handleChangeComplete}
          />
        )}
      </div>
    </div>
  </div>

const enhance = compose(
  withState('showPicker', 'setShowPicker', false),
  withHandlers({
    togglePicker: props => () => props.setShowPicker(!props.showPicker),
    handleChangeComplete: props => color => props.updateFormBgColor(color.hex),
  }),
);

export default enhance(BackgroundEditorBase);
